import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './CourseOverviewLearningOutcomes.module.css';

type CourseOverviewLearningOutcomesProps = ComponentProps & {
	fields: {
		LearningOutcomes?: Field<string>;
	};
};

export default function CourseOverviewLearningOutcomes(props: CourseOverviewLearningOutcomesProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	if (!props.fields?.LearningOutcomes?.value) {
		return <></>;
	}

	const outcomesArray = props.fields?.LearningOutcomes?.value
		?.replace(/<\/p>/g, '\r\n')
		?.replace(/<\/li>/g, '\r\n')
		?.replace(/<[^>]*>?/gm, '')
		?.replace(/\&nbsp;/g, '')
		?.split('\r\n')
		?.filter((lineItem) => lineItem.trim() !== '');

	return (
		<FieldEditFrame itemId={props.rendering?.dataSource ?? ''} fields={['LearningOutcomes']} header="Change learning outcomes">
			<EditorHelp text="Click here to change the learning outcomes" />
			<div className="padY padX maxWidth" id="resource-navigation" data-display-pdf-download>
				<ContentOverviewHeaderContainer
					header={sitecoreContext.dictionary.learningOutcomesTitle}
					subHeader={sitecoreContext.dictionary.learningOutcomesSubtitle}
				/>

				<div className={styles.richTextContainer}>
					{outcomesArray?.length > 0 && outcomesArray.map((outcome, index) => <p key={index}>{outcome.trim()}</p>)}
				</div>
			</div>
		</FieldEditFrame>
	);
}
